import { render, staticRenderFns } from "./_base-infoauto-person-selector.vue?vue&type=template&id=4f674a0c"
import script from "./_base-infoauto-person-selector.vue?vue&type=script&lang=js"
export * from "./_base-infoauto-person-selector.vue?vue&type=script&lang=js"
import style0 from "./_base-infoauto-person-selector.vue?vue&type=style&index=0&id=4f674a0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports